export function state () {
  return {
    employers: [],
    employer: null
  }
}

export default state